const pt = {
  // Navbar
  nav: { plans: "Planos", howItWorks: "Como Funciona", contact: "Contato", support: "Suporte", consultData: "Consultar Dados", login: "Login", portal: "Portal Cliente", crm: "CRM", services: "Serviços", chipMobile: "Chip NewSky Mobile", wifiService: "NewSky WiFi" },

  // Hero
  hero: {
    brand: "Mobile",
    overline: "A conexão que você precisa no Japão",
    headline: "Internet + Número Telefônico Japonês",
    headlineAccent: "sem burocracia!",
    sub: "Sem multa ao cancelar! Use o tempo que precisar!",
    sub2: "Chip físico ou eSIM com suporte em seu idioma!",
    ctaBuy: "Solicitar o meu!",
    ctaPlans: "Ver planos",
  },

  // Benefits
  benefits: {
    overline: "Vantagens",
    title: "Tudo que você precisa",
    items: [
      { title: "Conexão estável em todo Japão", desc: "Cobertura 4G/5G de alta velocidade em todas as regiões do Japão." },
      { title: "Super econômico", desc: "Planos a partir de ¥3,480/mês com ligações incluídas." },
      { title: "Sem burocracia", desc: "Processo simples e rápido. Sem contratos longos." },
      { title: "Pagamento em konbini ou cartão", desc: "Pague do jeito que for mais fácil. Konbini, cartão de crédito ou transferência." },
      { title: "Taxa de ativação promocional", desc: "Aproveite a taxa de ativação com desconto especial." },
      { title: "Chip físico ou eSIM no mesmo dia", desc: "Escolha entre SIM físico ou eSIM. Ativação imediata." },
    ],
  },

  // Plans
  plans: {
    overline: "Planos",
    title: "Escolha seu plano ideal",
    sub: "Planos com número japonês, dados e ligações. Comece a usar hoje.",
    basic: "Básico",
    popular: "Popular",
    premium: "Premium",
    badge: "Mais Escolhido",
    unlimitedCalls: "Ligações ilimitadas",
    calls60: "60 min ligações",
    month: "mês",
    optional: "Opcional",
    unlimitedPlus: "Ligações ilimitadas",
    activationFee: "Taxa única de ativação: ¥3,300",
    cta: "Quero mais informações",
    features: {
      data: "de dados",
      callsUnlimited: "Ligações ilimitadas",
      calls60min: "60 min de ligações",
      jpNumber: "Número japonês",
      simOrEsim: "Chip físico ou eSIM",
      supportPt: "Suporte em português",
      supportPriority: "Suporte prioritário",
    },
  },

  // How it works
  howItWorks: {
    overline: "Simples e rápido",
    title: "Como funciona",
    steps: [
      { title: "Escolha o plano", desc: "Selecione o plano ideal para suas necessidades de dados e ligações." },
      { title: "Receba o chip ou eSIM", desc: "Receba seu SIM físico em casa ou ative o eSIM instantaneamente." },
      { title: "Ative e use", desc: "Insira o chip ou escaneie o QR code do eSIM. Pronto, você está conectado!" },
    ],
  },

  // Trust
  trust: {
    overline: "Confiança e Tradição",
    title: "Mais de 25 anos conectando brasileiros no Japão",
    desc: "A NewSky está presente no Japão há mais de duas décadas, oferecendo serviços de telecomunicação com atendimento dedicado em português, espanhol e inglês. São mais de 100 mil clientes satisfeitos que confiam na nossa experiência.",
    stats: { years: "Anos no Japão", customers: "Clientes atendidos", languages: "Idiomas de suporte", response: "Resposta rápida" },
    langs: ["Português", "Espanhol", "Inglês"],
  },

  // Contact
  contact: {
    overline: "Fale conosco",
    title: "Entre em contato",
    form: { name: "Nome", email: "Email", phone: "Telefone", message: "Mensagem", namePh: "Seu nome", emailPh: "seu@email.com", phonePh: "090-XXXX-XXXX", messagePh: "Como podemos ajudar?", submit: "Enviar mensagem", sending: "Enviando...", success: "Mensagem enviada!", error: "Erro. Tente novamente." },
    info: { tokyo: "Tokyo", email: "Email", whatsapp: "WhatsApp", whatsappSub: "Atendimento somente por texto", hours: "Horário de atendimento", monFri: "Segunda a Sexta", sat: "Sábado", hq: "NewSky - Headquarter", hqAddr: "163-1030 Tokyo-to Shinjuku-ku Nishi-Shinjuku 3-7-1 Shinjuku Park Tower N30F", hqNote: "(não há atendimento ao cliente)", office: "NewSky - Balcão de Atendimento ao Cliente", officeAddr: "485-0048 Aichi-ken Komaki-shi MamaHonMachi 123 BB komaki Bldg. 3F" },
  },

  // Final CTA
  finalCta: {
    overline: "Não perca mais tempo",
    title: "Chegue no Japão já conectado",
    desc: "Tenha seu número japonês e internet funcionando antes mesmo de sair do aeroporto. Fale conosco agora.",
    cta: "Solicitar o meu!",
  },

  // Support page
  supportPage: {
    overline: "Central de Ajuda",
    title: "Como podemos ajudar?",
    sub: "Encontre respostas para as perguntas mais frequentes ou entre em contato com nossa equipe.",
    searchPh: "Buscar no suporte...",
    faqTitle: "Perguntas Frequentes",
    noResults: "Nenhum resultado encontrado para",
    needHelp: "Ainda precisa de ajuda?",
    whatsapp: "WhatsApp",
    whatsappSub: "Resposta rápida",
    phone: "Telefone",
    emailLabel: "Email",
    backHome: "Voltar ao início",
    faqs: [
      { q: "Como ativar meu eSIM?", a: "Após a compra, você receberá um QR Code por email. Basta acessar as configurações do seu celular, ir em 'Dados Móveis' ou 'Rede Celular', selecionar 'Adicionar Plano' e escanear o QR Code. Seu eSIM será ativado em poucos minutos." },
      { q: "Quais celulares são compatíveis com eSIM?", a: "A maioria dos smartphones modernos são compatíveis, incluindo iPhone XS e posteriores, Samsung Galaxy S20+, Google Pixel 3 e posteriores. Consulte-nos no WhatsApp para verificar a compatibilidade do seu aparelho." },
      { q: "Posso manter meu número atual?", a: "Sim! Oferecemos o serviço de portabilidade (MNP). Você pode transferir seu número atual para a NewSky Mobile. Entre em contato conosco para mais detalhes sobre o processo." },
      { q: "Como funciona o pagamento no konbini?", a: "Você receberá um boleto por email ou SMS que pode ser pago em qualquer konbini (7-Eleven, FamilyMart, Lawson, etc). O pagamento é processado em até 24 horas." },
      { q: "Qual a cobertura da rede?", a: "Nossa rede cobre todo o território japonês, incluindo áreas rurais. Utilizamos a infraestrutura das principais operadoras do Japão, garantindo conexão 4G/5G de alta qualidade em todo o país." },
      { q: "Posso cancelar a qualquer momento?", a: "Sim! Nossos planos não possuem fidelidade ou multa de cancelamento. Você pode cancelar a qualquer momento entrando em contato conosco pelo WhatsApp ou telefone." },
      { q: "Como recebo o chip físico?", a: "O chip físico é enviado pelos Correios japoneses (JP Post). Normalmente a entrega leva de 1 a 3 dias úteis. Você também pode retirar em nosso escritório em Tokyo." },
      { q: "Preciso de documentos para contratar?", a: "Sim, para contratar você precisa de um documento de identificação válido (passaporte ou Residence Card). O processo é simples e pode ser feito totalmente pelo WhatsApp." },
    ],
  },

  // Consultar Dados
  consultar: {
    title: "Consultar Uso de Dados",
    desc: "Para checar o consumo de dados e informações do seu chip NewSky Mobile, insira o número do seu SIM Card",
    label: "Número do SIM Card",
    placeholder: "Digite o número do SIM",
    button: "Consultar",
    consulting: "Consultando...",
    result: "Resultado da Consulta",
    newSearch: "Fazer nova consulta",
    simInfo: "O número do SIM Card está impresso no cartão do chip ou pode ser encontrado nas configurações do seu aparelho.",
    number: "Número",
    dataUsage: "Consumo de Dados",
    used: "utilizado",
    remaining: "restante",
    plan: "Plano",
    network: "Rede",
    sim: "SIM",
    voice: "Voz",
    sms: "SMS",
    planStart: "Início Plano",
    active: "Ativo",
    suspended: "Suspenso",
    details: "Detalhes do SIM",
    serialNumber: "Serial Number",
    activation: "Ativação",
    calls: "Ligações",
    callsUnlimited: "Ilimitadas (70 min/ligação)",
    planStartDate: "Início do Plano",
    planEndDate: "Fim do Plano",
    noExpiry: "Sem vencimento",
    error: "Erro ao consultar. Tente novamente.",
    notFound: "SIM não encontrado ou número inválido",
  },

  // Footer
  footer: { back: "Voltar" },

  // WiFi page
  wifi: {
    overline: "WiMAX 5G — Internet Ilimitada",
    headline: "Internet de alta velocidade",
    headlineAccent: "em qualquer lugar!",
    sub: "Sem fios. Sem técnico. Sem taxa de instalação. Sem longa espera.",
    sub2: "Internet ilimitada para toda a família em segundos!",
    ctaBuy: "Solicitar o meu!",
    ctaPlans: "Ver planos",
    familyText: "Internet para toda a família!",
    benefitsTitle: "Por que escolher NewSky WiFi?",
    benefitsOverline: "Vantagens",
    benefits: [
      { title: "Sem fios, sem instalação", desc: "Chegou, ligou, conectou! Sem técnico em casa, sem furos na parede, sem espera." },
      { title: "Internet ilimitada", desc: "Dados ilimitados para streaming, trabalho, jogos e toda a família." },
      { title: "Leve para onde quiser", desc: "Em casa, no trabalho, em viagem. Bateria de longa duração para uso o dia todo." },
      { title: "Sem altas taxas", desc: "Sem taxa de instalação absurda. Sem taxas extras em mudanças de endereço." },
      { title: "Conecte até 16 dispositivos", desc: "Celular, notebook, tablet, smart TV, videogame — todos ao mesmo tempo." },
      { title: "Velocidade 5G WiMAX", desc: "Tecnologia de ponta com máximo desempenho para sua conexão." },
    ],
    plansOverline: "Planos",
    plansTitle: "Escolha sua forma de pagamento",
    plansSub: "Internet ilimitada WiMAX 5G — Aparelho 100% novo!",
    konbini: "💴 Pagamento em Konbini",
    card: "💳 Débito Automático no Cartão",
    planSky1: "Plano Sky 1",
    planSky2: "Plano Sky 2",
    tabRent: "Alugar Aparelho",
    tabBuy: "Comprar Aparelho",
    month: "/mês",
    unlimitedRental: "Internet ilimitada + aluguel do aparelho",
    deviceNew: "🎉 APARELHO 100% NOVO!",
    activationFee: "Taxa de ativação",
    shippingFee: "Frete todo Japão",
    totalInitial: "Total inicial",
    monthlyLabel: "Mensalidade:",
    campaign: "Campanha Especial",
    buyBonus: "🎁 Na compra você ganha:",
    exempt: "ISENTA",
    free: "GRÁTIS",
    shippingFree: "para todo Japão",
    monthlyReduction: "Mensalidade",
    unlimitedInternet: "Internet ilimitada",
    paymentKonbini: "📅 Pagamento entre os dias 2 e 15 do mês posterior",
    paymentCard: "💳 Débito automático no cartão no mês posterior",
    noCancel: "✓ Sem multa de cancelamento",
    minPeriod: "⏱ Período mínimo: 2 meses",
    cta: "Quero mais informações",
    konbiniNote: "Valor a pagar ao entregador ao receber em casa:",
    cardNote: "Enviaremos a fatura para pagamento seguro via cartão:",
  },

  portal: {
    loginTitle: "Portal do Cliente",
    loginSub: "Acesse seus serviços e pagamentos",
    email: "Email",
    emailPh: "seu@email.com",
    password: "Senha",
    passwordPh: "Sua senha",
    enter: "Entrar",
    demo: "Entrar com conta Demo",
    forgot: "Esqueci minha senha",
    forgotTitle: "Recuperação de Senha",
    forgotDesc: "Para redefinir sua senha, entre em contato com nosso suporte:",
    forgotClose: "Fechar",
    backToSite: "Voltar ao site",
    // Layout
    portalLabel: "Portal",
    nav: { home: "Início", services: "Serviços", payments: "Pagamentos", support: "Suporte", account: "Minha Conta", logout: "Sair" },
    // Dashboard
    hello: "Olá,",
    welcome: "Bem-vindo ao seu portal NewSky Mobile",
    monthlyTotal: "TOTAL MENSAL",
    pending: "PENDENTE",
    myServices: "Meus Serviços",
    viewAll: "Ver todos",
    noActiveService: "Nenhum serviço ativo",
    nextBilling: "Próx. cobrança:",
    overdueWarning: "Atenção: {count} serviço(s) com pagamento vencido",
    overdueContact: "Entre em contato com o suporte para regularizar.",
    pendingPayments: "Pagamentos Pendentes",
    dueDate: "Vencimento:",
    overdue: "ATRASADO",
    pendingLabel: "PENDENTE",
    month: "/mês",
    // Services
    myServicesTitle: "Meus Serviços",
    noServiceFound: "Nenhum serviço encontrado",
    since: "Desde",
    upgrade: "Upgrade",
    downgrade: "Downgrade",
    cancel: "Cancelar",
    requestTitle: "Solicitar",
    requestDesc: "Descreva sua solicitação...",
    sendRequest: "Enviar Solicitação",
    cancelBtn: "Cancelar",
    myRequests: "Minhas Solicitações",
    reqType: "Tipo",
    reqDetails: "Detalhes",
    reqDate: "Data",
    reqStatus: "Status",
    reqPending: "Pendente",
    reqApproved: "Aprovado",
    reqRejected: "Rejeitado",
    statusActive: "ATIVO",
    statusOverdue: "VENCIDO",
    statusCancelled: "CANCELADO",
    // Payments
    paymentsTitle: "Pagamentos",
    totalPaid: "Total Pago",
    pendingAmount: "Pendente",
    overdueAmount: "Atrasado",
    openInvoices: "Faturas Abertas",
    invoices: "Faturas",
    payNow: "Pagar Agora",
    paid: "PAGO",
    open: "ABERTA",
    history: "Histórico",
    noPayment: "Nenhum pagamento",
    amount: "Valor",
    dueDateLabel: "Vencimento",
    paymentDate: "Pagamento",
    status: "Status",
    // Support
    supportTitle: "Suporte",
    supportEmpty: "Envie uma mensagem para iniciar o atendimento.",
    supportTeam: "Nossa equipe responderá em breve.",
    typePlaceholder: "Digite sua mensagem...",
    // Account
    accountTitle: "Minha Conta",
    personalData: "Dados Pessoais",
    name: "Nome",
    nameChangeNote: "Para alterar o nome, entre em contato com o suporte.",
    phone: "Telefone",
    save: "Salvar Alterações",
    saved: "Dados atualizados com sucesso!",
  },
};

export default pt;
